import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/portal/mdf/drafts/:id — partner discards an in-progress draft.
// Bucket 9 shipped the route + service helper but not a hook; sub-bucket 3
// adds it for the draft-edit view's "Discard draft" footer button. Server
// reference-counts attachment storage_keys on delete (no orphan sweep).
//
// Caller is responsible for navigation on success (typically back to
// /portal/mdf).
export function useDeleteMdfDraft() {
  const queryClient = useQueryClient();
  return useMutation<void, ApiClientError, { id: string }>({
    mutationFn: async ({ id }) => {
      await apiFetch<void>(`/portal/mdf/drafts/${id}`, { method: "DELETE" });
    },
    onSuccess: (_data, { id }) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.requests() });
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.draft(id) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to discard draft");
    },
  });
}
